export const APP_VERSION = "1.0.0";

export const ENABLE_REDUX_DEV_TOOLS = true;

export const THEMES = {
    LIGHT: "LIGHT",
    DARK: "DARK"
};

export const REDUX_ACTIONS = {
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    INITIALIZE: "INITIALIZE",
    UPDATE_USER: "UPDATE_USER"
};

export const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[()[\]{},;.:\-_@#<>!?|"'£$%&/=+*^~])(?=\S+$).{8,}$/;

export const USER_ROLES = {
    USER: {role: "USER", label: "User"},
    ADMIN: {role: "ADMIN", label: "Admin"}
};

export const API_ROLES = {
    API: {role: "API", label: "Api"}
};

export const TENANT_TYPES = {
    RESELLER: {type: "RESELLER", label: "Reseller"},
    RETAIL: {type: "RETAIL", label: "Retail"}
};

export const ORGANISATION_TYPES = {
    RESELLER: {type: "OV", label: "OV"}
    //RETAIL: { type: "EV", label: "EV" }
};

export const HOSTS_CONFIG = {
    localhost: {
        brand: "devs",
        defaultLanguage: "en",
        supportedLanguages: ["en", "it"]
    },
    "localhost.dadapro.net": {
        brand: "devs",
        defaultLanguage: "en",
        supportedLanguages: ["en", "it"]
    },

    "ssl.cloud-integration.dadapro.net": {
        brand: "devs",
        defaultLanguage: "en",
        supportedLanguages: ["en", "it"]
    },
    "int-ssl.register.it": {
        brand: "register.it",
        defaultLanguage: "it",
        supportedLanguages: ["en", "it"]
    },
    "int-ssl.nominalia.com": {
        brand: "nominalia.com",
        defaultLanguage: "es",
        supportedLanguages: ["es", "ca", "en"]
    },

    "ssl.cloud-staging.dadapro.net": {
        brand: "devs",
        defaultLanguage: "en",
        supportedLanguages: ["en", "it"]
    },
    "stg-ssl.register.it": {
        brand: "register.it",
        defaultLanguage: "it",
        supportedLanguages: ["en", "it"]
    },
    "stg-ssl.nominalia.com": {
        brand: "nominalia.com",
        defaultLanguage: "es",
        supportedLanguages: ["es", "ca", "en"]
    },
    "stg-ssl.dominios.pt": {
        brand: "dominios.pt",
        defaultLanguage: "pt",
        supportedLanguages: ["pt"]
    },
    "stg-ssl.keliweb.it": {
        brand: "keliweb.it",
        defaultLanguage: "it",
        supportedLanguages: ["it", "en"]
    },
    "stg-ssl.papaki.com": {
        brand: "papaki.com",
        defaultLanguage: "el",
        supportedLanguages: ["el", "en"]
    },
    "stg-ssl.webempresa.com": {
        brand: "webempresa.com",
        defaultLanguage: "es",
        supportedLanguages: ["es", "en"]
    },
    "stg-ssl.hostingireland.ie": {
        brand: "hostingireland.ie",
        defaultLanguage: "en",
        supportedLanguages: ["en"]
    },
    "stg-ssl.letshost.ie": {
        brand: "letshost.ie",
        defaultLanguage: "en",
        supportedLanguages: ["en"]
    },

    "ssl.cloud.dadapro.net": {
        brand: "register.it",
        defaultLanguage: "it",
        supportedLanguages: ["it", "en"]
    },
    "ssl.register.it": {
        brand: "register.it",
        defaultLanguage: "it",
        supportedLanguages: ["it", "en"]
    },
    "ssl.nominalia.com": {
        brand: "nominalia.com",
        defaultLanguage: "es",
        supportedLanguages: ["es", "ca", "en"]
    },
    "int-ssl.amen.fr": {
        brand: "amen.fr",
        defaultLanguage: "fr",
        supportedLanguages: ["fr", "en"]
    },
    "stg-ssl.amen.fr": {
        brand: "amen.fr",
        defaultLanguage: "fr",
        supportedLanguages: ["fr", "en"]
    },
    "ssl.amen.fr": {
        brand: "amen.fr",
        defaultLanguage: "fr",
        supportedLanguages: ["fr", "en"]
    },
    "int-ssl.amen.pt": {
        brand: "amen.pt",
        defaultLanguage: "pt",
        supportedLanguages: ["pt", "en"]
    },
    "stg-ssl.amen.pt": {
        brand: "amen.pt",
        defaultLanguage: "pt",
        supportedLanguages: ["pt", "en"]
    },
    "ssl.amen.pt": {
        brand: "amen.pt",
        defaultLanguage: "pt",
        supportedLanguages: ["pt", "en"]
    },
    "ssl.amenworld.nl": {
        brand: "amen.nl",
        defaultLanguage: "en",
        supportedLanguages: ["en"]
    },
    "ssl.dominios.pt": {
        brand: "dominios.pt",
        defaultLanguage: "pt",
        supportedLanguages: ["pt"]
    },
    "ssl.keliweb.it": {
        brand: "keliweb.it",
        defaultLanguage: "it",
        supportedLanguages: ["it", "en"]
    },
    "ssl.papaki.com": {
        brand: "papaki.com",
        defaultLanguage: "el",
        supportedLanguages: ["el", "en"]
    },
    "ssl.webempresa.com": {
        brand: "webempresa.com",
        defaultLanguage: "es",
        supportedLanguages: ["es", "en"]
    },
    "ssl.hostingireland.ie": {
        brand: "hostingireland.ie",
        defaultLanguage: "en",
        supportedLanguages: ["en"]
    },
    "ssl.letshost.ie": {
        brand: "letshost.ie",
        defaultLanguage: "en",
        supportedLanguages: ["en"]
    },
    "int-ssl.swizzonic.ch": {
        brand: "swizzonic.ch",
        defaultLanguage: "de",
        supportedLanguages: ["en", "fr", "it", "de"]
    },
    "stg-ssl.swizzonic.ch": {
        brand: "swizzonic.ch",
        defaultLanguage: "de",
        supportedLanguages: ["en", "fr", "it", "de"]
    },
    "ssl.swizzonic.ch": {
        brand: "swizzonic.ch",
        defaultLanguage: "de",
        supportedLanguages: ["en", "fr", "it", "de"]
    }
};

export const VETTING_TYPES = {
    DV: "DV",
    OV: "OV",
    EV: "EV"
};

export const WEBSERVER_TYPES = {
    apache: {value: "apache", label: "Apache"},
    iis: {value: "iis", label: "Microsoft IIS"},
    plesk: {value: "plesk", label: "Plesk"},
    cpanel: {value: "cpanel", label: "cPanel"},
    other: {value: "other", label: "Other"}
};

export const DOMAIN_APPROVAL = {
    email: {key: "email", value: "EMAIL", label: "Email"},
    dns: {key: "dns", value: "DNS", label: "DNS"},
    dnsauto: {key: "dnsauto", value: "DNS_AUTO", label: "DNS Auto"}
};

export const CANCEL_ORDER_EXCLUDED_PRODUCTS = [
    "SEC_POSITIVE_DV_SAN",
    "SEC_SECTIGO_EV_SAN",
    "SEC_INSTANT_OV_SAN",
    "SEC_ENTERPRISE_PRO_OV_SAN",
    "SEC_ENTERPRISE_PRO_EV_SAN"
];
